{
  "version": 1,
  "asset_id": "859146b9-ce0e-43fb-8964-5915d610fe61",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/859146b9-ce0e-43fb-8964-5915d610fe61/lecanto-metal-roof-after-768w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/859146b9-ce0e-43fb-8964-5915d610fe61/lecanto-metal-roof-after-768w.avif",
  "original_filename": "lecanto-metal-roof-after-768w.avif",
  "size": 46574,
  "content_type": "image/avif",
  "created_at": "2026-07-21T19:37:47Z"
}
